import { Injectable } from '@angular/core';
import { CartExportService, Customer } from 'gung-standard';

@Injectable({
  providedIn: 'root'
})
export class TyloCartExportService extends CartExportService {
  getCustomerCurrency(customer: Customer): string {
    return customer.extra?.kus?.valkod;
  }
}
